function TechStackComponent({ logo, name }: any) {
  return (
    <div className="bg-gray-3 rounded-md w-[100px] h-[100px] md:w-[130px] md:h-[120px] flex flex-col items-center justify-center">
      <div className="w-[35px] h-[35px] md:w-[50px] md:h-[50px] overflow-hidden rounded mb-3">
        <img
          src={logo}
          alt="thumbnail"
          className="object-cover w-full h-full"
        />
      </div>
      <p className="text-[14px]">{name}</p>
    </div>
  );
}

export default TechStackComponent;
